export default "__VITE_ASSET__BSpAGnGa__"